
import { hydrateCSRTemplate } from "@fiverr-private/layout_lib/CSRTemplate";

import FloatingChat from '/home/circleci/app/packages/layout-floating-chat-component/src/entries/FloatingChat';

const element = typeof document !== 'undefined' && document.querySelector('#FloatingChat');
if (element) {
    const props = window.initialData['FloatingChat'];

    hydrateCSRTemplate(FloatingChat, props, element, 'FloatingChat', 'FloatingChat');
}
export default FloatingChat;
